/**
 * A dummy project id to use in events where you really should provide a project
 * id, but the database schema stupidly has the project id as an optional field
 */
export const DUMMY_PROJECT_ID = '7C4E69C5-F376-4646-8F3A-E992A763B14C'
